import { FaTimes, FaSave } from "react-icons/fa";
import { PrimaryButton, SecondaryButton } from "../../../UI/DesignStandards";

const PrizeFundEditActions = ({
  editMode,
  user,
  canManage,
  isSubmitting,
  isPayoutFinalized,
  onCancel,
  onSave,
}) => {
  if (!editMode || !user || !canManage) return null;

  return (
    <div className="flex justify-end space-x-3 pt-4">
      <SecondaryButton onClick={onCancel}>
        <FaTimes className="mr-2" />
        Cancel
      </SecondaryButton>
      <PrimaryButton
        onClick={onSave}
        disabled={isSubmitting || isPayoutFinalized}
        title={
          isPayoutFinalized
            ? "Payouts have been locked and cannot be changed"
            : "Save your changes"
        }
      >
        {isSubmitting ? (
          <>
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
            Saving...
          </>
        ) : (
          <>
            <FaSave className="mr-2" />
            Save Changes
          </>
        )}
      </PrimaryButton>
    </div>
  );
};

export default PrizeFundEditActions;
